import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../../assets/images/logo_blanc.png";
import "./header.css";

const GuestHeader = () => {
  const history = useHistory();

  const handleLogoClick = () => {
    history.push("/login");
  };

  return (
    <header className="siteHeader">
      <div className="headerInner headerInner--guest">
        <div className="headerLogo" onClick={handleLogoClick} aria-label="Accueil - Connexion">
          <img src={logo} alt="Éditions Langloÿs" />
        </div>

        <div className="headerRightContent">
          <div className="discoverBtn">
            Barème Rapide® Digital
          </div>
        </div>
      </div>
    </header>
  );
};

export default GuestHeader;
